{
  "app": {
    "onboarding": {
      "logoTitle": "MedOnboard",
      "logoSubtitle": "Faculty and Staff Onboarding",
      "supportEmail": "som-facultyonboarding@stanford.edu"
    },
    "candidate-portal": {
      "logoTitle": "Onboarding Portal",
      "logoSubtitle": "Questionnaire and To-Do List",
      "loginAccessDescription": "Looks like you need a new login link.  Please enter the email address associated with your Stanford onboarding and we will email you a new link.  Once you get the email, just click the link it contains and you will be logged in the Stanford Candidate Onboarding Portal.",
      "loginAccessContactInfo": "If you are still having issues please contact <5>{{supportEmail}}</5> for help.",
      "supportEmail": "som-facultyonboarding@stanford.edu"
    },
    "act": {
      "logoTitle": "MedACT",
      "logoSubtitle": "Appointment Compensation Tool",
      "supportEmail": "som-facultyactions@stanford.edu"
    },
    "leave": {
      "logoTitle": "MedLeave",
      "logoSubtitle": "Faculty Leave Requests",
      "supportEmail": "som-leaves@stanford.edu",
      "supportEmailSubject": "MedLeave Contact Us Request",
      "helpLink": "https://med.stanford.edu/academicaffairs/tools/medleave.html"
    },
    "release": {
      "logoTitle": "Release Manager",
      "logoSubtitle": "AAS Product Release and Notification Tool",
      "supportEmail": ""
    },
    "copyrightYear": "2026"
  },
  "globals": {
    "autocomplete": {
      "noOptionsText": "No options",
      "typeToSearch": "Type a minimum of 3 characters",
      "helperText": "Please type a name to search.",
      "noResultsText": "No records with that name found."
    },
    "fieldHistory": {
      "tooltip": "Field History"
    },
    "actionHistory": {
      "tooltip": "Action History"
    },
    "fieldInfo": {
      "tooltip": "Field Info"
    },
    "recipientsText": "recipients",
    "help": "Help",
    "contactUs": "Contact Us"
  },
  "button": {
    "cancel": "Cancel",
    "back": "Cancel",
    "save": "Save",
    "submit": "Submit",
    "save_for_later": "Save for Later",
    "close": "Close",
    "delete_ssn": "View SSN and Delete from System"
  },
  "navigationPanel": {
    "attachments": "Attachments",
    "formErrors": "Form Errors"
  },
  "formStatus": {
    "initiated": "Initiated",
    "inProgress": "In Progress",
    "withdrawn": "Withdrawn",
    "returned": "Returned",
    "approved": "Approved",
    "completed": "Completed",
    "declined": "Declined",
    "draft": "Draft"
  },
  "deliveryStatus": {
    "sent": "Sent",
    "failed": "Failed"
  },
  "fileTypes": {
    "cv": "CV",
    "exceptionApproval": "Exception Approval",
    "letterOfInterest": "Letter of Interest",
    "chairMemo": "Chair Memo",
    "other": "Other",
    "termSheet": "Term Sheet",
    "offerLetter": "Offer Letter",
    "practicePolicyExemption": "Practice Policy Exemption (PPE)",
    "teachingCoursesExceptionQuestionnaire": "Teaching Courses Exception Questionnaire",
    "continuanceOfDutiesException": "Continuance of Duties Exception",
    "leaveRequestWithPayrollDocument": "Leave Request (with Payroll information)",
    "leaveRequest": "Leave Request",
    "signedOfferLetter": "Signed Offer Letter",
    "backgroundQuestionnaire": "Background Questionnaire"
  },
  "forms": {
    "notification": {
      "success": {
        "medonboard": "Form {{formTitle}} for candidate {{facultyName}} has been updated.",
        "medact": "Form {{formTitle}} for candidate {{facultyName}} has been updated.",
        "medleave": "Form {{formTitle}} for faculty {{facultyName}} has been updated.",
        "relman": "Release {{formTitle}} for project {{facultyName}} has been updated."
      }
    },
    "goBackConfirmationDialog": {
      "content": "You are about to discard your changes to the form. Are you sure?"
    },
    "historyDialog": {
      "title": "Field History: {{title}}",
      "columns": {
        "values": "Values",
        "updatedAt": "Updated At",
        "updatedBy": "Updated By"
      },
      "button": {
        "close": "Close"
      },
      "noHistoryText": "This field has no history yet."
    },
    "infoDialog": {
      "title": "Info: {{fieldName}}",
      "button": {
        "close": "Close"
      }
    },
    "validationMessage": {
      "date": {
        "invalidDate": "{{label}} is an invalid date format",
        "minDateFailure": "{{label}} should not be before minimal date",
        "maxDateFailure": "{{label}} should not be after maximal date"
      },
      "general": {
        "required": "{{label}} is a required field"
      }
    }
  },
  "dashboard": {
    "action": {
      "title": {
        "medonboard": "Onboarding Actions",
        "medact": "New Appointment Actions",
        "medleave": "Leave Requests",
        "relman": "Release Requests"
      },
      "create": {
        "medonboard": {
          "createButtonText": "Start Action"
        },
        "medact": {
          "createButtonText": "Start Action"
        },
        "medleave": {
          "createButtonText": "Start Request",
          "accrualCalculatorTitle": "Check Accrual",
          "accrualCalculatorTooltipTitle": ""
        },
        "relman": {
          "createButtonText": "Request Release"
        }
      },
      "notification": {
        "success": {
          "medonboard": "Onboarding Initiation Request for {{facultyName}} has been submitted.",
          "medact": "New Appointment Action for {{facultyName}} has been created.",
          "medleave": "Leave Initiation Request for {{facultyName}} has been submitted.",
          "relman": "New Release for {{facultyName}} has been created."
        }
      },
      "edit": {
        "notification": {
          "success": {
            "medonboard": "Onboarding Initiation Request for {{facultyName}} has been updated.",
            "medact": "Intake Information Form for {{facultyName}} has been saved.",
            "medleave": "Leave Initiation Request for {{facultyName}} has been updated.",
            "relman": "Release for {{facultyName}} has been updated."
          }
        }
      },
      "approved": {
        "notification": {
          "success": {
            "medonboard": "Onboarding Initiation Request for {{facultyName}} has been approved.",
            "medleave": "Leave Initiation Request for {{facultyName}} has been approved.",
            "relman": "Release for {{facultyName}} has been approved."
          }
        }
      },
      "list": {
        "tableColumns": {
          "medonboard": {
            "actionId": "Action ID",
            "candidateName": "Candidate Name",
            "hiringDepartment": "Hiring Department",
            "hiringDivision": "Hiring Division",
            "startDate": "Expected Start",
            "status": "Status",
            "candidateStatus": "Candidate Status",
            "links": "Links"
          },
          "medact": {
            "actionId": "Action ID",
            "candidateName": "Candidate Name",
            "hiringDepartment": "Primary Department",
            "hiringDivision": "Primary Division",
            "candidateLine": "Proposed Line",
            "startDate": "Proposed Start",
            "status": "Status",
            "links": "Links"
          },
          "medleave": {
            "requestId": "Req ID",
            "facultyName": "Faculty Name",
            "department": "Department",
            "division": "Division",
            "leaveType": "Type",
            "leaveStartDate": "Leave Start",
            "leaveEndDate": "Leave End",
            "status": "Status",
            "requestStatus": "Request Status",
            "links": "Links"
          },
          "relman": {
            "actionId": "Release ID",
            "releaseProject": "Project",
            "releaseTag": "Version",
            "releaseRolling": "Is Rolling Release Ok",
            "releaseHighProfile": "Is High Profile",
            "releaseRequiresCoordination": "Is Requires Coordination",
            "releaseRequestDate": "Requested Date",
            "status": "Status",
            "links": "Links"
          }
        },
        "tooltip": {
          "medonboard": {
            "action": "Onboarding Request",
            "approve": "Onboarding Request Review",
            "information": "Onboarding Information",
            "invitation": "Candidate Invitation",
            "summary": "Onboarding Summary",
            "todoList": "To-Do List",
            "ssn": "SSN Access",
            "resolution": "Onboarding Resolution",
            "questionnaire": "Questionnaire",
            "questionnaireReview": "Onboarding Release"
          },
          "medact": {
            "offerLetterIntakeInformation": "Offer Letter Intake Information",
            "offerLetterSummary": "Offer Letter Summary Review",
            "intakeInformation": "Term Sheet Intake Information",
            "termSheetDocument": "Term Sheet PDF",
            "offerLetterDocument": "Offer Letter PDF",
            "intakeInformationSchoolReviewer": "Term Sheet Intake Information",
            "fileAttachment": "File Attachments",
            "actionResolution": "Action Resolution"
          },
          "medleave": {
            "attachmentA": "Attachment A",
            "approveLeave": "Faculty Approve Leave",
            "approvalSummary": "Approval Summary",
            "dataSecurityAttestation": "Data Security Attestation",
            "leaveRequest": "Leave Request",
            "leaveSummary": "Leave Summary",
            "reviewLeave": "Reviewer Approve Leave",
            "requestResolution": "Request Resolution",
            "leaveRequestDocument": "Leave Request PDF",
            "leaveRequestPayrollDocument": "Leave Request with Payroll PDF"
          },
          "relman": {
            "requestRelease": "Request Release",
            "releaseRequestReviewer": "Request Release Reviewer",
            "releaseResolution": "Release Resolution"
          }
        },
        "noRecordsFound": "No Actions Found",
        "actionHistory": {
          "medact": {
            "title": "Action History for {{name}} (Action ID {{actionId}})",
            "columns": {
              "events": "Events",
              "triggeredAt": "Triggered At",
              "triggeredBy": "Triggered By"
            },
            "rows": {
              "eventTypes": {
                "actionChange": "Action Status changed to {{changeValue}}",
                "fieldChange": "{{changeStatus}} Status changed to {{changeValue}}",
                "emailNotification": {
                  "term_sheet_approved": "Term Sheet Approved Email {{deliveryStatus}}",
                  "term_sheet_returned": "Term Sheet Returned Email {{deliveryStatus}}",
                  "term_sheet_review_for_approval": "Term Sheet Review Email {{deliveryStatus}}",
                  "term_sheet_review_for_approval_school_reviewer": "Term Sheet School Review Email {{deliveryStatus}}",
                  "term_sheet_review_reminder": "Term Sheet Reminder Email {{deliveryStatus}}",
                  "term_sheet_updated_by_comp_reviewer_since_department_approval": "Term Sheet Comp Approval Updates Email {{deliveryStatus}}",
                  "term_sheet_updated_by_dept_reviewer_since_division_approval": "Term Sheet Dept Approval Updates Email {{deliveryStatus}}",
                  "offer_letter_approved": "Offer Letter Approved Email {{deliveryStatus}}",
                  "offer_letter_returned": "Offer Letter Returned Email {{deliveryStatus}}",
                  "offer_letter_review_for_approval": "Offer Letter Review Email {{deliveryStatus}}",
                  "offer_letter_review_for_approval_comp_reviewer": "Offer Letter Compensation Review Email {{deliveryStatus}}",
                  "offer_letter_review_for_approval_comp_reviewer_2": "Offer Letter Compensation Review 2 Email {{deliveryStatus}}",
                  "offer_letter_review_for_approval_school_reviewer": "Offer Letter School Review Email {{deliveryStatus}}",
                  "offer_letter_review_reminder": "Offer Letter Reminder Email {{deliveryStatus}}",
                  "offer_letter_updated_by_comp_reviewer_since_department_approval": "Offer Letter Comp Approval Updates Email {{deliveryStatus}}",
                  "offer_letter_updated_by_dept_reviewer_since_division_approval": "Offer Letter Dept Approval Updates Email {{deliveryStatus}}"
                },
                "documentArchived": "{{fileType}} Document Archived",
                "documentGenerated": "{{fileType}} Document Generated",
                "documentDeleted": "{{fileType}} file deleted: {{fileName}}",
                "documentRenamed": "{{fileType}} file renamed: {{previousFileName}} to {{fileName}}",
                "documentReplaced": "{{fileType}} file replaced: {{fileName}}",
                "documentUploaded": "{{fileType}} file uploaded: {{fileName}}",
                "documentMarkedObsolete": "Document Marked Obsolete"
              }
            },
            "button": {
              "close": "Close"
            },
            "noHistoryText": "This action has no history yet"
          },
          "medleave": {
            "title": "Action History for {{name}} (Action ID {{actionId}})",
            "columns": {
              "events": "Events",
              "triggeredAt": "Triggered At",
              "triggeredBy": "Triggered By"
            },
            "rows": {
              "eventTypes": {
                "actionChange": "Action Status changed to {{changeValue}}",
                "fieldChange": "Request Status changed to {{changeValue}}",
                "emailNotification": {
                  "request_returned_for_reapproval": "Returned for Reapproval Email {{deliveryStatus}}",
                  "request_review_for_approval_reminder": "Approval Reminder Email {{deliveryStatus}}",
                  "request_returned_by_faculty": "Returned by Faculty Email {{deliveryStatus}}",
                  "request_finally_approved_hr": "Leave Request Approved (HR) Email {{deliveryStatus}}",
                  "request_submitted_for_admin_review": "Submitted for Admin Review Email {{deliveryStatus}}",
                  "request_retracted": "Leave Request Retracted Email {{deliveryStatus}}",
                  "request_oaa_review_pending_reminder_fyi": "OAA Review Pending (FYI) Reminder Email {{deliveryStatus}}",
                  "request_finally_approved": "Leave Request Approved Email {{deliveryStatus}}",
                  "request_review_for_approval": "Submitted for Approval Email {{deliveryStatus}}",
                  "request_oaa_review_pending_reminder": "OAA Review Pending Reminder Email {{deliveryStatus}}",
                  "request_retracted_fyi": "Leave Request Retracted (FYI) Email {{deliveryStatus}}",
                  "request_denied": "Leave Request Denied Email {{deliveryStatus}}",
                  "request_submitted_for_faculty_review_reminder_fyi": "Faculty Review (FYI) Reminder Email {{deliveryStatus}}",
                  "request_review_for_approval_and_complete_dsa": "Submitted for Approval Email {{deliveryStatus}}",
                  "request_withdrawn": "Leave Request Withdrawn Email {{deliveryStatus}}",
                  "request_submitted_for_faculty_draft_reminder": "Faculty Draft Reminder Email {{deliveryStatus}}",
                  "request_submitted_for_faculty_review_reminder": "Faculty Review Reminder Email {{deliveryStatus}}",
                  "request_submitted_for_admin_review_reminder": "Admin Review Reminder Email {{deliveryStatus}}",
                  "request_submitted_for_faculty_review": "Submitted for Faculty Review Email {{deliveryStatus}}",
                  "request_returned_for_correction": "Returned for Correction Email {{deliveryStatus}}",
                  "notify_rpm_on_leave_date_change": "Leave Request Date Changed {{deliveryStatus}}"
                },
                "documentGenerated": "{{fileType}} Document Generated",
                "documentDeleted": "{{fileType}} file deleted: {{fileName}}",
                "documentRenamed": "{{fileType}} file renamed: {{previousFileName}} to {{fileName}}",
                "documentReplaced": "{{fileType}} file replaced: {{fileName}}",
                "documentUploaded": "{{fileType}} file uploaded: {{fileName}}",
                "documentMarkedObsolete": "Document Marked Obsolete",
                "pubsubNotification": "Notification Published to FL {{deliveryStatus}}"
              }
            },
            "button": {
              "close": "Close"
            },
            "noHistoryText": "This action has no history yet"
          },
          "medonboard": {
            "title": "Action History for {{name}} (Action ID {{actionId}})",
            "columns": {
              "events": "Events",
              "triggeredAt": "Triggered At",
              "triggeredBy": "Triggered By"
            },
            "rows": {
              "eventTypes": {
                "actionChange": "Action Status changed to {{changeValue}}",
                "fieldChange": "Candidate Status changed to {{changeValue}}",
                "emailNotification": {
                  "notification_to_admin_action_released": "Action Released Email {{deliveryStatus}}",
                  "action_declined": "Admin Action Declined Email {{deliveryStatus}}",
                  "action_withdrawn": "Admin Action Withdrawn Email {{deliveryStatus}}",
                  "approver_approves_action": "Action Approved Email {{deliveryStatus}}",
                  "approver_returns_with_comments": "Returned by Approver Email {{deliveryStatus}}",
                  "approver_withdraws_action": "Approver Withdrawn Email {{deliveryStatus}}",
                  "archive_record": "Action Resolution Email {{deliveryStatus}}",
                  "authority_assignment_missing_for_role_and_org": "Missing Assignment for Role Email {{deliveryStatus}}",
                  "clinics_at_stanford_hospital_and_lpch_1": "Stanford/LPCH Hospital 1 Email {{deliveryStatus}}",
                  "clinics_at_stanford_hospital_and_lpch_2": "Stanford/LPCH Hospital 2 Email {{deliveryStatus}}",
                  "clinics_at_stanford_hospital_and_lpch_3": "Stanford/LPCH Hospital 3 Email {{deliveryStatus}}",
                  "clinics_at_stanford_hospital_and_lpch_4": "Stanford/LPCH Hospital 4 Email {{deliveryStatus}}",
                  "clinics_at_stanford_hospital_and_lpch_5": "Stanford/LPCH Hospital 5 Email {{deliveryStatus}}",
                  "clinics_at_stanford_hospital_and_lpch_6": "Stanford/LPCH Hospital 6 Email {{deliveryStatus}}",
                  "clinics_at_stanford_hospital_and_lpch_7": "Stanford/LPCH Hospital 7 Email {{deliveryStatus}}",
                  "completed_candidate_questionnaire_for_review": "Candidate Completes Questionnaire Email {{deliveryStatus}}",
                  "department_submits_onboarding_request_for_approval": "Submitted for Review Email {{deliveryStatus}}",
                  "emergency_medicine_hr": "Emergency Medicine HR Email {{deliveryStatus}}",
                  "field_email_address_missing_for_notification": "Missing Email for Notification Email {{deliveryStatus}}",
                  "fyi_email": "FYI Contact Email {{deliveryStatus}}",
                  "fyi_email_to_courtesy_department_division": "Courtesy Department Email {{deliveryStatus}}",
                  "fyi_email_to_joint_department_division": "Joint Department Email {{deliveryStatus}}",
                  "hr": "Human Resources Email {{deliveryStatus}}",
                  "login_request": "Candidate Loging Request Email {{deliveryStatus}}",
                  "medicine_hr": "Human Resources Medicine Email {{deliveryStatus}}",
                  "mssd": "Medicial Staff Services Email {{deliveryStatus}}",
                  "notification_to_oaa_action_approved": "OAA Action Approved Email {{deliveryStatus}}",
                  "pediatrics_hr": "Human Resources Pediatrics Email {{deliveryStatus}}",
                  "psychiatry_and_behavioral_sciences_hr": "Human Resources Psychiatry Email {{deliveryStatus}}",
                  "reminder_div_to_approve_candidate_questionnaire": "Reminder Review Candidate Questionnaire Email {{deliveryStatus}}",
                  "reminder_to_admin_submit_onboarding_release": "Reminder Submit Onboarding Release Email {{deliveryStatus}}",
                  "reminder_to_admin_submit_onboarding_resolution": "Reminder Submit Onboarding Resolution Email {{deliveryStatus}}",
                  "reminder_to_approver": "Reminder Submitted for Review Email {{deliveryStatus}}",
                  "reminder_to_submit_candidate_intake": "Reminder to Submit Intake Email {{deliveryStatus}}",
                  "reminder_to_submit_candidate_questionnaire": "Reminder to Submit Questionnaire Email {{deliveryStatus}}",
                  "action_required_questionniare_ready_for_review": "Candidate Completes Questionnaire Email {{deliveryStatus}}",
                  "action_required_onboarding_release_ready_for_review": "Candidate Completes Questionnaire and Onboarding Information Email {{deliveryStatus}}",
                  "reminder_to_admin_submit_questionniare_ready_for_review": "Reminder Questionnaire Ready for Review Email {{deliveryStatus}}",
                  "rmg": "Office of Research Operations Email {{deliveryStatus}}",
                  "service_line_center": "Service Line Email {{deliveryStatus}}",
                  "stanford_affiliated_hospitals_or_clinics_1": "Affiliated Hospital/Clinic 1 Email {{deliveryStatus}}",
                  "stanford_affiliated_hospitals_or_clinics_2": "Affiliated Hospital/Clinic 2 Email {{deliveryStatus}}",
                  "stanford_affiliated_hospitals_or_clinics_3": "Affiliated Hospital/Clinic 3 Email {{deliveryStatus}}",
                  "stanford_affiliated_hospitals_or_clinics_4": "Affiliated Hospital/Clinic 4 Email {{deliveryStatus}}",
                  "stanford_affiliated_hospitals_or_clinics_5": "Affiliated Hospital/Clinic 5 Email {{deliveryStatus}}",
                  "stanford_affiliated_hospitals_or_clinics_6": "Affiliated Hospital/Clinic 6 Email {{deliveryStatus}}",
                  "stanford_affiliated_hospitals_or_clinics_7": "Affiliated Hospital/Clinic 7 Email {{deliveryStatus}}",
                  "summary_of_all_information_for_divisions": "Admin Release Summary Email {{deliveryStatus}}",
                  "surgery_hr": "Human Resources Surgery Email {{deliveryStatus}}",
                  "veterinary_service_center": "Veterinary Service Center Email {{deliveryStatus}}",
                  "welcome_email_to_candidate": "Candidate Welcome Email {{deliveryStatus}}"
                },
                "documentGenerated": "{{fileType}} Document Generated",
                "documentDeleted": "{{fileType}} file deleted: {{fileName}}",
                "documentRenamed": "{{fileType}} file renamed: {{previousFileName}} to {{fileName}}",
                "documentReplaced": "{{fileType}} file replaced: {{fileName}}",
                "documentUploaded": "{{fileType}} file uploaded: {{fileName}}",
                "documentMarkedObsolete": "Document Marked Obsolete"
              }
            },
            "button": {
              "close": "Close"
            },
            "noHistoryText": "This action has no history yet"
          },
          "relman": {
            "title": "Action History for {{name}} (Action ID {{actionId}})",
            "columns": {
              "events": "Events",
              "triggeredAt": "Triggered At",
              "triggeredBy": "Triggered By"
            },
            "rows": {
              "eventTypes": {
                "actionChange": "Action Status changed to {{changeValue}}",
                "fieldChange": "Term Sheet Status changed to {{changeValue}}",
                "emailNotification": {
                  "term_sheet_approved": "Term Sheet Approved Email {{deliveryStatus}}",
                  "term_sheet_returned": "Term Sheet Returned Email {{deliveryStatus}}",
                  "term_sheet_review_for_approval": "Term Sheet Review Email {{deliveryStatus}}",
                  "term_sheet_review_for_approval_school_reviewer": "Term Sheet School Review Email {{deliveryStatus}}",
                  "term_sheet_review_reminder": "Term Sheet Reminder Email {{deliveryStatus}}",
                  "term_sheet_updated_by_comp_reviewer_since_department_approval": "Term Sheet Comp Approval Updates Email {{deliveryStatus}}",
                  "term_sheet_updated_by_dept_reviewer_since_division_approval": "Term Sheet Dept Approval Updates Email {{deliveryStatus}}"
                },
                "documentGenerated": "{{fileType}} Document Generated",
                "documentDeleted": "{{fileType}} file deleted: {{fileName}}",
                "documentRenamed": "{{fileType}} file renamed: {{previousFileName}} to {{fileName}}",
                "documentReplaced": "{{fileType}} file replaced: {{fileName}}",
                "documentUploaded": "{{fileType}} file uploaded: {{fileName}}",
                "documentMarkedObsolete": "Document Marked Obsolete"
              }
            },
            "button": {
              "close": "Close"
            },
            "noHistoryText": "This action has no history yet"
          }
        }
      },
      "filter": {
        "sectionTitle": "Filters",
        "fields": {
          "medonboard": {
            "lastName": {
              "label": "Last Name"
            },
            "firstName": {
              "label": "First Name"
            },
            "hiringDepartment": {
              "label": "Hiring Department"
            },
            "hiringDivision": {
              "label": "Hiring Division"
            },
            "startDate": {
              "label": "Expected Start",
              "minDate": "First date cannot be after second date"
            },
            "dateSeparator": {
              "label": "to"
            },
            "endDate": {
              "label": "Expected End",
              "maxDate": "Second date cannot be before first date"
            },
            "status": {
              "label": "Status"
            }
          },
          "medact": {
            "actionId": {
              "label": "Action Id"
            },
            "lastName": {
              "label": "Last Name"
            },
            "firstName": {
              "label": "First Name"
            },
            "hiringDepartment": {
              "label": "Primary Department"
            },
            "hiringDivision": {
              "label": "Primary Division"
            },
            "line": {
              "label": "Proposed Line"
            },
            "rank": {
              "label": "Proposed Rank"
            },
            "startDate": {
              "label": "Proposed Start",
              "minDate": "First date cannot be after second date"
            },
            "dateSeparator": {
              "label": "to"
            },
            "endDate": {
              "maxDate": "Second date cannot be before first date"
            },
            "termSheetStatus": {
              "label": "Status"
            }
          },
          "medleave": {
            "lastName": {
              "label": "Faculty Last Name"
            },
            "firstName": {
              "label": "Faculty First Name"
            },
            "hiringDepartment": {
              "label": "Department"
            },
            "hiringDivision": {
              "label": "Division"
            },
            "leaveType": {
              "label": "Leave Type"
            },
            "startDate": {
              "label": "Leave Start Date",
              "minDate": "First date cannot be after second date"
            },
            "startDateBegin": {
              "label": "Leave Start Beginning Date",
              "minDate": "First date cannot be after second date"
            },
            "dateSeparator": {
              "label": "to"
            },
            "startDateEnd": {
              "label": "Leave Start Through Date",
              "maxDate": "Second date cannot be before first date"
            },
            "endDate": {
              "label": "Leave End Date",
              "minDate": "First date cannot be after second date"
            },
            "endDateBegin": {
              "label": "Leave End Beginning Date",
              "minDate": "First date cannot be after second date"
            },
            "endDateEnd": {
              "label": "Leave End Through Date",
              "maxDate": "Second date cannot be before first date"
            },
            "status": {
              "label": "Leave Status"
            },
            "requestStatus": {
              "label": "Request Status"
            },
            "rpmContact": {
              "label": "RPM Contact"
            },
            "actionId": {
              "label": "Request Id"
            }
          },
          "relman": {
            "actionId": {
              "label": "Action Id"
            },
            "releaseProject": {
              "label": "Project Name"
            },
            "releaseTag": {
              "label": "Project Version"
            },
            "releaseRolling": {
              "label": "Rolling Release Ok"
            },
            "releaseHighProfile": {
              "label": "High Profile"
            },
            "releaseRequiresCoordination": {
              "label": "Requires Coordination"
            },
            "releaseRequestDate": {
              "label": "Requested Date",
              "minDate": "First date cannot be after second date"
            },
            "dateSeparator": {
              "label": "to"
            },
            "endDate": {
              "maxDate": "Second date cannot be before first date"
            },
            "releaseStatus": {
              "label": "Status"
            }
          }
        },
        "fieldValues": {
          "status": {
            "initiated": "Initiated",
            "approved": "Approved",
            "inProgress": "In Progress",
            "withdrawn": "Withdrawn",
            "declined": "Declined",
            "completed": "Completed",
            "returned": "Returned"
          }
        },
        "resetLabel": "Reset All Filters"
      }
    }
  },
  "fileAttachments": {
    "title": {
      "medonboard": "File Attachments for {{name}} (Action ID {{actionId}})",
      "medact": "File Attachments for {{name}} (Action ID {{actionId}})",
      "medleave": "File Attachments for {{name}} (Action ID {{actionId}})"
    },
    "button": {
      "uploadAttachments": {
        "label": {
          "medonboard": "Upload Attachment",
          "medact": "Upload Attachment",
          "medleave": "Upload Attachment"
        }
      }
    },
    "list": {
      "tableColumns": {
        "medonboard": {
          "fileType": "File Type",
          "fileName": "Filename",
          "updatedAt": "Updated At",
          "updatedBy": "Updated By",
          "operations": "Operations"
        },
        "medact": {
          "fileType": "File Type",
          "fileName": "Filename",
          "updatedAt": "Updated At",
          "updatedBy": "Updated By",
          "operations": "Operations"
        },
        "medleave": {
          "fileType": "File Type",
          "fileName": "Filename",
          "updatedAt": "Updated At",
          "updatedBy": "Updated By",
          "operations": "Operations"
        }
      },
      "tooltip": {
        "medonboard": {
          "download": "Download",
          "edit": "Rename",
          "delete": "Delete"
        },
        "medact": {
          "download": "Download",
          "edit": "Rename",
          "delete": "Delete"
        },
        "medleave": {
          "download": "Download",
          "edit": "Rename",
          "delete": "Delete"
        }
      },
      "actionButtons": {
        "back": "Dashboard"
      },
      "noRecordsFound": "No File Attachments Found"
    },
    "uploadAttachmentsDialog": {
      "title": "Upload Attachment",
      "fields": {
        "uploader": {
          "label": "Drag 'n' Drop a file here, or Click to Select file.",
          "acceptedFilesLabel": "(Only {{extensions}} will be accepted)"
        }
      },
      "actionButtons": {
        "cancel": {
          "label": "CANCEL"
        },
        "upload": {
          "label": "UPLOAD"
        }
      },
      "confirmation": {
        "upload": "Are you sure you want to upload the file \"{{fileName}}\"?",
        "replace": "Are you sure you want to replace the file \"{{fileName}}\"?"
      },
      "notification": {
        "someErrorOccurred": "Some error occurred",
        "fileSizeLimitHelperText": "Maximum file size limit is 10 MB",
        "success": {
          "upload": "\"{{fileName}}\" has been uploaded.",
          "replace": "\"{{fileName}}\" has been replaced."
        }
      },
      "error": {
        "fileTypeNotSupported": "{{fileName}} is invalid. File type not supported.",
        "fileSizeLimitExceeded": "{{fileName}} is invalid. File size limit exceeded."
      }
    },
    "renameDialog": {
      "title": "Rename (File Type: {{fileType}})",
      "actionButtons": {
        "cancel": {
          "label": "CANCEL"
        },
        "rename": {
          "label": "Rename"
        }
      },
      "notification": {
        "success": "\"{{oldFileName}}\" has been renamed to \"{{newFileName}}\"."
      }
    },
    "deleteDialog": {
      "title": "Delete Confirmation",
      "content": "Are you sure you want to delete the file \"{{fileName}}\"?",
      "actionButtons": {
        "cancel": {
          "label": "CANCEL"
        },
        "delete": {
          "label": "DELETE"
        }
      },
      "notification": {
        "success": "\"{{oldFileName}}\" file has been deleted."
      }
    }
  },
  "portal": {
    "portalLogin": {
      "description": "Please enter the email address below and we will email you an unique login link right away.",
      "emailField": {
        "label": "Email Address"
      },
      "submitButton": "GET LOGIN LINK",
      "inProcessButton": "REQUESTING ...",
      "notification": {
        "success": "If the email you entered exists in our records, an email will be sent right away with your new unique login link. Please add our Candidate Onboarding Email {{supportEmail}} to your contact list and check your Spam Folder if you do not receive an email.",
        "tryAgain": "Click here If you have still have not received an email with your new link and want to request a new email link.",
        "error": "Unable to submit request at the moment."
      }
    },
    "portalForm": {
      "description": {
        "header": "Welcome to the Stanford Medicine Candidate Onboarding Portal. Stanford Medicine has started the process to consider you for an appointment in the School of Medicine. Please do the following:",
        "listItemOne": "First, complete and submit the INTAKE form as soon as possible.",
        "listItemTwo": "Next, complete and save the QUESTIONNAIRE form.",
        "listItemThree": "Last, view your TO-DO LIST containing various tasks specific to your onboarding. You may check items as complete and save your changes as you move through the onboarding process."
      }
    },
    "portalFormURL": {
      "intakeURL": "intake",
      "questionnaireURL": "questionnaire",
      "todolistURL": "todolist"
    }
  }
}